import { GlIcon, GlLink, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import Tracking from '../../../tracking/index.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import TooltipOnTruncateDirective from '../../../vue_shared/directives/tooltip_on_truncate.js?vue3';
import UserAvatarLink from '../../../vue_shared/components/user_avatar/user_avatar_link.vue?vue3';
import { ICONS, PIPELINE_ID_KEY, PIPELINE_IID_KEY, TRACKING_CATEGORIES } from '~/ci/constants';
import CommitPopover from '../../../vue_shared/components/commit_popover.vue?vue3';
import PipelineLabels from './pipeline_labels.vue?vue3';
export default {
    name: 'PipelineUrl',
    components: {
        CommitPopover,
        GlIcon,
        GlLink,
        PipelineLabels,
        UserAvatarLink
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        TooltipOnTruncate: TooltipOnTruncateDirective
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        pipeline: {
            type: Object,
            required: true
        },
        pipelineIdType: {
            type: String,
            required: false,
            default: PIPELINE_ID_KEY,
            validator (value) {
                return value === PIPELINE_IID_KEY || value === PIPELINE_ID_KEY;
            }
        }
    },
    computed: {
        mergeRequestRef () {
            return this.pipeline?.merge_request || this.pipeline?.mergeRequest;
        },
        commitRef () {
            return this.pipeline?.ref;
        },
        commitTag () {
            return this.commitRef?.tag || this.pipeline?.type === 'tag';
        },
        commitUrl () {
            return this.pipeline?.commit?.commit_path || this.pipeline?.commit?.webPath || this.pipeline?.commitPath;
        },
        commitShortSha () {
            return this.pipeline?.commit?.short_id || this.pipeline?.commit?.shortId;
        },
        popoverTargetId () {
            return `pipeline-commit-popover-${this.commitShortSha}`;
        },
        refUrl () {
            return this.commitRef?.ref_url || this.commitRef?.path || `commits/${this.pipeline?.ref}`;
        },
        commitAuthor () {
            const pipelineCommit = this.pipeline?.commit;
            const pipelineCommitAuthor = pipelineCommit?.author;
            // 1. The author is a GitLab user with an avatar
            if (pipelineCommitAuthor?.avatar_url || pipelineCommitAuthor?.avatarUrl) {
                return pipelineCommitAuthor;
            }
            // 2. The author is a GitLab user without an avatar; REST provides a Gravatar for the commit email
            if (pipelineCommitAuthor) {
                if (!pipelineCommit.author_gravatar_url) {
                    return null;
                }
                return {
                    ...pipelineCommitAuthor,
                    avatar_url: pipelineCommit.author_gravatar_url
                };
            }
            // 3. The author is not a GitLab user, or `commit` is not readable: use the commit's author fields
            const name = pipelineCommit?.author_name || this.pipeline?.commitAuthorName;
            if (!name) {
                return null;
            }
            return {
                avatar_url: pipelineCommit?.author_gravatar_url || this.pipeline?.commitAuthorGravatar,
                path: pipelineCommit?.author_email && `mailto:${pipelineCommit.author_email}`,
                username: name,
                name
            };
        },
        commitIcon () {
            let name = '';
            if (this.commitTag) {
                name = ICONS.TAG;
            } else if (this.mergeRequestRef) {
                name = ICONS.MR;
            } else {
                name = ICONS.BRANCH;
            }
            return name;
        },
        commitIconTooltipTitle () {
            switch(this.commitIcon){
                case ICONS.TAG:
                    return __('Tag');
                case ICONS.MR:
                    return __('Merge Request');
                default:
                    return __('Branch');
            }
        },
        pipelineId () {
            return getIdFromGraphQLId(this.pipeline[this.pipelineIdType]);
        },
        pipelineName () {
            return this.pipeline?.name || '';
        },
        pipelineSecondaryLink () {
            const pipelineSchedule = this.pipeline?.pipelineSchedule || this.pipeline?.pipeline_schedule;
            if (pipelineSchedule) {
                return {
                    text: pipelineSchedule.description,
                    href: pipelineSchedule.editPath || pipelineSchedule.path
                };
            }
            const commitTitle = this.pipeline?.commit?.title || this.pipeline?.commitTitle;
            if (commitTitle) {
                return {
                    text: commitTitle,
                    href: this.commitUrl,
                    trackingAction: 'click_commit_title'
                };
            }
            return null;
        }
    },
    methods: {
        trackClick (action) {
            this.track(action, {
                label: TRACKING_CATEGORIES.table
            });
        }
    }
};
